/* unplugin-vue-components disabled */import script from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignInButton.vue?vue&type=style&index=0&id=c8b3f56e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b3f56e"]])

export default __exports__